import { useViewSwitchContext } from "../contexts/ViewSwitchContext";
import { EmployeesPresence } from "./EmployeesPresence";
import { MyPresence } from "./MyPresence";

export const ViewOutlet = () => {
  const { view } = useViewSwitchContext();

  if (view === "my") {
    return <MyPresence />;
  }

  if (view === "employees") {
    return <EmployeesPresence />;
  }

  return null;
};
